// https://stackoverflow.com/questions/2450954
export const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

export const getRandomElements = (array, count) => {
    shuffleArray(array);
    return array.slice(0, count);
}
